// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3330": "1852a85d","3859": "e5ac1b0c","494": "40775784","7047": "ed1a6d53",}[chunkId] + ".css"
}